// App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar"
import "./App.css";
import Footer from "./components/footer";
import Company from "./pages/Company";
import Innovation from "./pages/Innovation";
import Breadcrumb from "./components/Breadcrumb";
import ScrollBar from "./components/ScrollBar";
import Cloud from "./pages/cloud";
import Industries from "./pages/Industries";
import Cybersecurity from "./pages/Cybersecurity";
import Contact from "./pages/contact";
import Careers from "./pages/career";
import Services from "./pages/services";
import ViksitBharat from "./pages/ViksitBharat";
import ISRSystems from "./pages/ISRSystems";
import StellarConnect from "./pages/Connect";
import Connect from "./pages/products/Connect";
import Edge from "./pages/products/Edge";
import Discovery from "./pages/products/Discovery";
import Payments from "./pages/products/Payments";
import CloudProduct from "./pages/products/Cloud";
import AIAgents from "./pages/products/AIAgents";
import ProductsHome from "./pages/products/ProductsHome";





const App: React.FC = () => {
  return (
    <Router>
      <Navbar />
       <Breadcrumb />
       <ScrollBar />
      <div className="page-content">
        <Routes>
          <Route path="/" element={<Company />} />
          <Route path="/company" element={<Company />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/Cybersecurity" element={<Cybersecurity />} />
          <Route path="/services" element={<Services />} />
          <Route path="/Cloud" element={<Cloud />} />
          <Route path="/connect" element={<StellarConnect />} />
          <Route path="/industries" element={<Industries/>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/viksit-bharat" element={<ViksitBharat/>} />
          <Route path="/viksit-bharat/isr-systems" element={<ISRSystems/>} />
          <Route path="/products/connect" element={<Connect />} />
          <Route path="/products/edge" element={<Edge />} />
          <Route path="/products/discovery" element={<Discovery />} />
          <Route path="/products/payments" element={<Payments />} />
          <Route path="/products/cloud" element={<CloudProduct />} />
          <Route path="/products/ai-agents" element={<AIAgents />} />
          <Route path="/products" element={<ProductsHome />} />
          
         

        </Routes>
      </div>
     <Footer/>
    </Router>
  );
};

export default App;
